/**
 * API Configuration Module
 * 
 * Configures API base URLs dynamically based on environment (development, staging, production).
 */

const ENV_CMS_API_URLS = {
  staging: 'https://api.zoplop.nexuslinkdev.com/admin/api/v1/cms/public',
  production: 'https://api.kabx.ca/admin/api/v1/cms/public',
};

/**
 * Resolves the active environment name ('development', 'staging', 'production').
 */
export const getEnvironment = () => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'staging';
  return env.toLowerCase();
};

/**
 * Retrieves the CMS API base URL for the current environment.
 * Order of precedence:
 * 1. process.env.REACT_APP_CMS_API_URL (Explicit environment variable override)
 * 2. Environment lookup table based on getEnvironment()
 * 3. Development fallback URL
 */
export const getCmsApiBaseUrl = () => {
  if (process.env.REACT_APP_CMS_API_URL) {
    return process.env.REACT_APP_CMS_API_URL;
  }
  const currentEnv = getEnvironment();
  return ENV_CMS_API_URLS[currentEnv] || ENV_CMS_API_URLS.staging;
};

/**
 * Gets the URL for fetching the public CMS list.
 */
export const getCmsListUrl = () => {
  return `${getCmsApiBaseUrl()}?pagination=false`;
};

/**
 * Gets the URL for fetching single CMS page details by ID.
 * @param {string} cmsId 
 */
export const getCmsDetailUrl = (cmsId) => {
  return `${getCmsApiBaseUrl()}/${cmsId}`;
};

const apiConfig = {
  getEnvironment,
  getCmsApiBaseUrl,
  getCmsListUrl,
  getCmsDetailUrl,
};

export default apiConfig;
